import { useState, useEffect, useContext } from 'react'
import dayjs from 'dayjs'
import GlobalContext from '../../../../../../context/global-context'
import Lottie from 'lottie-react'
import LoaderAdm from '../../../../../../assets/svgIcons/LoaderAdm.json'
// api
import { OrganizationAPI } from '../../../../../../api/organization.api'
// components
import TableComprobante from './TableComprobante'
import ModalNuevoMiContador from '../../../../modalDialogMiContador/ModalNuevoMiContador'
import FilterControl from '../../../../table/FilterControl'
import FilterInput from '../../../../table/FilterInputControl'
import FilterDateControl from '../../../../table/FilterDateControl'
import CustomButton from '../../../../ui/CustomButton'
// import { ExportCSV, ExportXLS } from '../../../../table/ExportData'
import translations from '../../../../ui/traslation/traslationMiContador.json'
import CustomPagination from '../../../../table/CustomPagination'
// import ExportPDFMIContador from '../../../../table/typesExportPDF/ExportPDFMiContador'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import clsx from 'clsx'

const List = () => {
  const { currentBusiness } = useContext(GlobalContext)
  const [isLoadingData, setIsLoadingData] = useState(false)
  const [comprobantes, setComprobantes] = useState([])
  const [rowsPerPage, setRowsPerPage] = useState(-1)
  const [filters, setFilters] = useState({
    estadoComprobante: 'todos',
    tipoComprobante: '',
    usuario: '',
    comprobante: '',
    fechaInicio: dayjs().startOf('month').format('YYYY-MM-DD'),
    fechaFin: dayjs().format('YYYY-MM-DD'),
    tipoDocumento: '',
    tipoDocumentoFiltro: '',
    razonSocial: ''
  })
  const [tempFilters, setTempFilters] = useState({ ...filters })
  const [openNuevoComprobante, setOpenNuevoComprobante] = useState(false)
  const organizationAPI = new OrganizationAPI()
  const [openEditModal, setOpenEditModal] = useState(false)
  const [switchGetData, setSwitchGetData] = useState(false)
  const [showFilters, setShowFilters] = useState(true)
  const [page, setPage] = useState(0)
  const [order, setOrder] = useState({
    col: '',
    field: '',
    direction: 'asc'
  })
  const handleOpenNuevoComprobante = () => {
    setOpenNuevoComprobante(true)
  }

  const normalizeComprobantesResponse = response => {
    if (Array.isArray(response?.data?.libros)) return response.data.libros
    if (Array.isArray(response?.data)) return response.data
    return []
  }

  const mergeComprobantes = (...lists) => {
    const uniqueComprobantes = new Map()

    lists.flat().forEach(comprobante => {
      if (!comprobante) return

      const fallbackKey = [
        comprobante?.comprobante,
        comprobante?.fecha,
        comprobante?.tipoComprobanteId,
        comprobante?.validation
      ].join('-')

      const key = comprobante?.id ?? fallbackKey
      uniqueComprobantes.set(key, comprobante)
    })

    return Array.from(uniqueComprobantes.values()).sort((a, b) => {
      const dateA = new Date(a?.updatedAt || a?.fecha || 0).getTime()
      const dateB = new Date(b?.updatedAt || b?.fecha || 0).getTime()
      return dateB - dateA
    })
  }

  // Función para obtener datos dependiendo del estado del comprobante
  const apiGetDataTable = async updatedFilters => {
    setIsLoadingData(true)
    try {
      const { estadoComprobante, fechaInicio, fechaFin } = updatedFilters

      if (estadoComprobante === 'todos') {
        const [aprobadosResponse, borradoresResponse] = await Promise.all([
          organizationAPI.getLibroComprobantes(
            currentBusiness.id,
            fechaInicio,
            fechaFin,
            'aprobados'
          ),
          organizationAPI.getLibroComprobantes(
            currentBusiness.id,
            fechaInicio,
            fechaFin,
            'borradores'
          )
        ])

        setComprobantes(
          mergeComprobantes(
            normalizeComprobantesResponse(aprobadosResponse),
            normalizeComprobantesResponse(borradoresResponse)
          )
        )
        return
      }

      const response = await organizationAPI.getLibroComprobantes(
        currentBusiness.id,
        fechaInicio,
        fechaFin,
        estadoComprobante
      )
      setComprobantes(normalizeComprobantesResponse(response))
    } catch (error) {
      console.error('Error al obtener los comprobantes:', error)
    } finally {
      setIsLoadingData(false)
    }
  }

  useEffect(() => {
    apiGetDataTable(filters) // Llama a la API inicialmente con los filtros predeterminados
    setSwitchGetData(false)
  }, [currentBusiness, switchGetData === true])

  const getUsuariosOptions = () => {
    const uniqueUsers = new Set()

    // Extraer los usuarios de los comprobantes
    comprobantes.forEach(comprobante => {
      if (Array.isArray(comprobante.createUser)) {
        // Si createUser es un array, añadir todos los nombres
        comprobante.createUser.forEach(user => uniqueUsers.add(`@${user.firstname}`))
      } else if (comprobante.createUser?.firstname) {
        // Si es un solo objeto, añadir el nombre
        uniqueUsers.add(`@${comprobante.createUser.firstname}`)
      } else {
        // Si no hay usuarios, asignar @Luca
        uniqueUsers.add('@Luca')
      }
    })

    // Convertir el Set a un array y añadir la opción 'Todos'
    return [
      { value: '', label: 'Todos' },
      ...Array.from(uniqueUsers).map(user => ({ value: user, label: user }))
    ]
  }

  const handleSearch = () => {
    setFilters({ ...tempFilters })
    apiGetDataTable(tempFilters)
  }

  const getTipoPorLibro = (libroId) => {
    const id = Number(libroId);
    if ([24, 26, 31, 34].includes(id)) return 'vinculaciones';
    if ([1, 6, 13].includes(id)) return 'venta';
    if ([3, 7, 14].includes(id)) return 'compra';
    if (id === 5) return 'remuneraciones';
    if (id === 37) return 'form29';
    if ([11, 4, 12].includes(id)) return 'honorarios';
    return null; // no agregar 'otros' al filtro
   };

    // Saca todos los libroContableOriginTableId existentes en la lista
  const tiposPresentes = [
    ...new Set(
      comprobantes
        ?.map(c => getTipoPorLibro(c.libroContableOriginTableId))
        .filter(Boolean) // elimina nulls o undefined
    )
  ];

  const opcionesTipo = [
    { value: '', label: 'Todos' },
    ...tiposPresentes.map(tipo => ({
      value: tipo,
      label:
        tipo === 'vinculaciones' ? 'Vinculaciones' :
        tipo === 'venta' ? 'Venta' :
        tipo === 'compra' ? 'Compra' :
        tipo === 'honorarios' ? 'Honorarios' :
        tipo === 'remuneraciones' ? 'Remuneraciones' :
        tipo === 'form29' ? 'Formulario 29' :
        tipo
    }))
  ];

  const getFilteredComprobantes = () => {
    const normalizeSearchText = value =>
      String(value ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()

    return comprobantes
      .map((comprobante) => {
        const userDisplay =
          Array.isArray(comprobante.createUser) && comprobante.createUser.length > 0
            ? comprobante.createUser.map((user) => `@${user.firstname}`).join(', ')
            : comprobante.createUser?.firstname
            ? `@${comprobante.createUser.firstname}`
            : '@Luca';
  
        const tipoMovimiento = getTipoPorLibro(comprobante.libroContableOriginTableId);
  
        // Obtener tipo de documento desde listaAuxiliar
        const tipoDocumento = comprobante.listaAuxiliar?.find(aux => aux.tipoDocumento)?.tipoDocumento || 'desconocido';
  
        // Filtros aplicados
        const tipoMovimientoMatch = filters.tipoDocumento
          ? tipoMovimiento === filters.tipoDocumento
          : true;
  
        const tipoDocumentoMatch = filters.tipoDocumentoFiltro
          ? comprobante.listaAuxiliar?.some(aux => aux.tipoDocumento === filters.tipoDocumentoFiltro)
          : true;
  
        const tipoMatch = filters.tipoComprobante
          ? comprobante.tipoComprobante?.name === filters.tipoComprobante
          : true;
  
        const usuarioMatch = filters.usuario ? userDisplay === filters.usuario : true;
  
        const comprobanteMatch = filters.comprobante
          ? comprobante.comprobante?.toString().includes(filters.comprobante.toString())
          : true;

        const searchTerm = normalizeSearchText(filters.razonSocial)
        const searchableValues = [
          comprobante.glosa,
          comprobante.razonSocial,
          comprobante.descripcion,
          ...((comprobante.listaAuxiliar || []).flatMap(aux => [
            aux.razonSocial,
            aux.glosa,
            aux.descripcion
          ]))
        ]
        const razonSocialMatch = !searchTerm || searchableValues.some(value =>
          normalizeSearchText(value).includes(searchTerm)
        )
  
        return tipoMatch && usuarioMatch && comprobanteMatch && tipoMovimientoMatch && tipoDocumentoMatch && razonSocialMatch
          ? { ...comprobante, userDisplay, tipoDocumento }
          : null;

      })
      .filter(Boolean);
  }

  // Prepara los datos filtrados para exportación
  const dataToExport = getFilteredComprobantes()
  // const yearFilter = dayjs().year() // Año actual para exportación
  
  //const icons = [
    // <ExportCSV
    //   key='export-csv'
    //   currentBusiness={currentBusiness.name}
    //   rut={currentBusiness.rut}
    //   data={dataToExport}
    //   title='Reportes libro diario'
    //   year={yearFilter}
    // />,
    // <ExportXLS
    //   key='export-xls'
    //   currentBusiness={currentBusiness.name}
    //   rut={currentBusiness.rut}
    //   data={dataToExport}
    //   title='Reportes libro diario'
    //   year={yearFilter}
    // />,
    // <ExportPDFMIContador
    //   key='export-pdf'
    //   currentBusiness={currentBusiness.name}
    //   rut={currentBusiness.rut}
    //   data={dataToExport}
    //   title='Reportes libro diario'
    //   year={yearFilter}
    // />
  //]

  const handleClearFilters = () => {
    const initialFilters = {
      estadoComprobante: 'todos',
      tipoComprobante: '',
      usuario: '',
      comprobante: '',
      fechaInicio: dayjs().startOf('month').format('YYYY-MM-DD'),
      fechaFin: dayjs().format('YYYY-MM-DD'),
      tipoDocumento: '',
      tipoDocumentoFiltro: '',
      razonSocial: ''
    }
    setTempFilters(initialFilters)
    setFilters(initialFilters)
    apiGetDataTable(initialFilters)
  }
  
  const getTipoDocumentoOptions = () => {
    const uniqueTipoDocumentos = new Set()
    comprobantes.forEach(comprobante => {
      comprobante.listaAuxiliar?.forEach(aux => {
        if (aux.tipoDocumento) {
          uniqueTipoDocumentos.add(aux.tipoDocumento)
        }
      })
    })
    return [
      { value: '', label: 'Todos' },
      ...Array.from(uniqueTipoDocumentos).map(tipo => ({ value: tipo, label: tipo }))
    ]
  }

  useEffect(() => {
    if (!openEditModal) {
      apiGetDataTable(filters)
    }
  }, [openEditModal])
  
  const handleChangePage = newPage => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = newRows => {
    setRowsPerPage(newRows)
    setPage(0) // Reiniciar página
  }

  const handleSort = ({ col, field }) => {
    const isAsc = order.col === col && order.direction === 'asc'
    setOrder({ col, field, direction: isAsc ? 'desc' : 'asc' })
  }

  const sortRows = () => {
    return [...dataToExport].sort((a, b) => {
      const valA = a[order.field]
      const valB = b[order.field]

      if (valA == null) return 1
      if (valB == null) return -1

      if (order.direction === 'asc') {
        return valA < valB ? -1 : valA > valB ? 1 : 0
      } else {
        return valA > valB ? -1 : valA < valB ? 1 : 0
      }
    })
  }

  const sortedData = sortRows()
  const paginatedData = rowsPerPage > 0
    ? sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : sortedData

  return (
    <div className='relative'>
      <div className='absolute top-[-20px] right-0 z-20 flex items-center space-x-2'>
        {/*<div className='flex space-x-2'>
          {icons.map((icon) => icon)}
        </div>*/}
        <button
          className='rounded-full px-2 py-2 bg-accent2 text-white text-sm font-sans'
          onClick={handleOpenNuevoComprobante}
        >
          {translations.actions.nuevoComprobante}
        </button>
      </div>
      <div className=" p-4 mt-6 bg-white rounded-3xl shadow-md flex flex-col overflow-hidden font-sans" style={{ height: 'calc(100vh - 12rem)' }}>
        {showFilters && (
        <div className="flex flex-wrap items-start gap-x-2 gap-y-4 border rounded-3xl p-4 bg-gray-50 mb-2 mt-1">
          <div className="min-w-[150px] pt-2">
            <FilterDateControl
            label='Fecha Desde'
            value={tempFilters.fechaInicio}
            onChange={newValue =>
              setTempFilters({ ...tempFilters, fechaInicio: dayjs(newValue).format('YYYY-MM-DD') })
            }
          />
          </div>
          <div className="min-w-[150px] pt-2">
            <FilterDateControl
            label='Fecha Hasta'
            value={tempFilters.fechaFin}
            onChange={newValue =>
              setTempFilters({ ...tempFilters, fechaFin: dayjs(newValue).format('YYYY-MM-DD') })
            }
          />
          </div>
          <div className="min-w-[150px] pt-2">
            <FilterControl
            label='Estado del Comprobante'
            value={tempFilters.estadoComprobante}
            onChange={value => setTempFilters({ ...tempFilters, estadoComprobante: value })}
            options={[
              { value: 'todos', label: 'Todos' },
              { value: 'aprobados', label: 'Aprobado' },
              { value: 'borradores', label: 'Borrador' }
            ]}
          />
          </div>
          <div className="min-w-[150px] pt-2">
            <FilterControl
            label='Tipo de Comprobante'
            value={tempFilters.tipoComprobante}
            onChange={value => setTempFilters({ ...tempFilters, tipoComprobante: value })}
            options={[
              { value: '', label: 'Todos' },
              { value: 'Ingreso', label: 'Ingreso' },
              { value: 'Egreso', label: 'Egreso' },
              { value: 'Traspaso', label: 'Traspaso' }
            ]}
          />
          </div>
          <div className="min-w-[150px] pt-2">
            <FilterControl
            label='Usuario'
            value={tempFilters.usuario}
            onChange={value => setTempFilters({ ...tempFilters, usuario: value })}
            options={getUsuariosOptions()}
          />
          </div>
          <div className="min-w-[150px] pt-2">
            <FilterControl
              label="Tipo de Movimientos"
              value={tempFilters.tipoDocumento}
              onChange={(value) => setTempFilters({ ...tempFilters, tipoDocumento: value })}
              options={opcionesTipo}
            />
          </div>
          <div className="min-w-[150px] pt-2">
            <FilterControl
            label='Tipo de Documentos'
            value={tempFilters.tipoDocumentoFiltro}
            onChange={value => setTempFilters({ ...tempFilters, tipoDocumentoFiltro: value })}
            options={getTipoDocumentoOptions()}
          />
          </div>
          <div className="min-w-[150px] pt-2">
            <FilterInput
            label='Nro de Comprobante'
            value={tempFilters.comprobante}
            onChange={value => setTempFilters({ ...tempFilters, comprobante: value })}
          />
          </div>
          <div className="min-w-[150px] pt-2">
            <FilterInput
              label='Glosa o Razón Social'
              value={tempFilters.razonSocial || ''}
              onChange={value => {
                setTempFilters(current => ({ ...current, razonSocial: value }))
                setFilters(current => ({ ...current, razonSocial: value }))
                setPage(0)
              }}
            />
          </div>
          <div className="flex flex-wrap items-center gap-2 pt-2">
            <CustomButton
              title='BUSCAR'
              color='primary'
              onClick={handleSearch}
              className='rounded-full'
            />
            <CustomButton
              className='rounded-full'
              color='accent1'
              title='LIMPIAR'
              onClick={handleClearFilters}
            />
          </div>
          <div className="ml-auto pt-2">
            <button
              className="flex items-center px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
              onClick={() => setShowFilters(f => !f)}
            >
              <KeyboardArrowDownIcon className={clsx('transition-transform', { 'rotate-180': showFilters })} />
            </button>
          </div>
        </div>
        )}
        {!showFilters && (
          <div className="flex justify-end mb-4 mt-2">
            <button
              className="flex items-center px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
              onClick={() => setShowFilters(f => !f)}
            >
              <KeyboardArrowDownIcon className={clsx('transition-transform', { 'rotate-180': showFilters })} />
            </button>
          </div>
        )}
          <div className='mb-4 flex flex-wrap gap-4'></div>

          {isLoadingData ? (
          <div className="flex items-center justify-center h-full">
            <Lottie animationData={LoaderAdm} loop style={{ width: 300, height: 300 }} />
          </div>
        ) : (
          <>
            {dataToExport.length > 0 ? (
              <div className="flex-1 min-h-0 overflow-auto pb-2">
                <TableComprobante
                  comprobantes={paginatedData}
                  onSort={handleSort}
                  order={order}
                  setComprobantes={setComprobantes}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  apiGetDataTable={apiGetDataTable}
                  openEditModal={openEditModal}
                  setOpenEditModal={setOpenEditModal}
                  setSwitchGetData={setSwitchGetData}
                />
              </div>
            ) : (
              <p className='text-center text-gray-500 mt-4'>No se encontraron datos.</p>
            )}
            {/* {console.log(dataToExport.filter(row=>row.userDisplay.startsWith('')))} */}
            {(paginatedData.length > 0 || dataToExport.length > 0) && (
              <div className='mt-4'>
                <CustomPagination
                  count={dataToExport.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            )}
          </>
        )}
      </div>

      {openNuevoComprobante && (
        <ModalNuevoMiContador
          title='NuevoComprobante'
          openNuevoComprobante={openNuevoComprobante}
          setOpenNuevoComprobante={setOpenNuevoComprobante}
          setSwitchGetData={setSwitchGetData}
        />
      )}
    </div>
  )
}

export default List
